<div class="workspace bg-radial">
  <top-bar [titleTranslationCode]="'NAVIGATION.LESSONS'"
           [redirectLink]="'../../'"
           [redirectTranslationCodes]="'NAVIGATION.LESSONS'"
           class="accent">
    <footer>
      <div class="row d-none d-md-flex">
        <div class="col-10">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item" aria-current="page">
                <a routerLink="../..">
                  {{ "NAVIGATION.LESSONS" | translate }}
                </a>
              </li>
              <li class="breadcrumb-item" aria-current="page">
                <a routerLink="../..">
                  {{ "LESSONS.WEEKLY_PLANNED_LESSONS" | translate }}
                </a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                {{ getScheduleName() }}
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </footer>
  </top-bar>
  <div class="container">
    <room-details [room]="room"></room-details>
  </div>
</div>
